module.exports = __webpack_public_path__ + "static/media/and.20c75b04.png";